export const getPackagesCountString = (packageCount) => {
  if (packageCount === 1) {
    return "ps_entity_package";
  } else {
    return "ps_entity_package_plural";
  }
};

